







































import { Component, Mixins } from 'vue-property-decorator'

import AppEmptyCard from '@/components/AppEmptyCard.vue'
import AppTitleBar from '@/components/AppTitleBar.vue'
import AppTwoColsCard from '@/components/AppTwoColsCard.vue'
import gql from 'graphql-tag'
import { Common } from '@/mixins'

@Component({
  components: {
    AppEmptyCard,
    AppTitleBar,
    AppTwoColsCard
  },
  apollo: {
    getOrderDeliverySummary: {
      query () {
        return gql`query getOrderDeliverySummary($orderDeliveryId: ID!) {
          getOrderDeliverySummary(orderDeliveryId: $orderDeliveryId) {
            carrierName
            trackNo
            sender
            status
            progresses {
              date
              location
              status
            }
          }
        }`
      },
      variables () {
        return {
          orderDeliveryId: this.$route.params.id
        }
      }
    }
  }
})
export default class extends Mixins(Common) {
  getOrderDeliverySummary = {}

  toTimeText (timestamp: number) {
    const date = new Date(timestamp * 1000)
    const { hours, minutes, seconds } = this.getDateNumbers(date)

    return `${hours}:${minutes}.${seconds}`
  }
}
